import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { h1, link, paragraphLarge, paragraphRegular, subtitle } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled, { css } from 'styled-components';
const Container = styled(SectionWrapper) `
  --sectionSpacingBottom: ${fluid(32, 64)};
  --sectionSpacingTop: ${fluid(32, 64)};

  border-bottom-right-radius: ${fluid(26, 50)};
  color: ${brand.blue.navy};

  /* If no CTA Links are displayed, reduce the bottom spacing to compensate for the Read More Button */
  &:has(:not(${ButtonStyles.Container})) {
    --sectionSpacingBottom: calc(${fluid(32, 64)} - ${fluid(20, 26)});
  }

  ${SectionWrapperStyles.Inner} {
    ${baseGrid};

    grid-template-rows: min-content 1fr min-content;
  }
`;
const leftColumns = css `
  grid-column: 1 / -1;

  @media ${from(Device.TabletLarge)} {
    grid-column: 1 / span 6;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 1 / span 5;
  }
`;
const rightColumns = css `
  grid-column: 1 / -1;

  @media ${from(Device.TabletLarge)} {
    grid-column: 7 / span 6;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 7 / span 5;
  }
`;
const Title = styled.h1 `
  ${leftColumns};
  ${h1};

  margin: 0;
`;
const Subtitle = styled.p `
  ${leftColumns};
  ${subtitle};
`;
const Introduction = styled.div `
  ${rightColumns};

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 24px 0 0;

  p {
    ${paragraphLarge};
    ${fonts.proximaNova.medium};

    margin: 0;

    ${Container}[data-read-all='false'] & {
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  @media ${from(Device.TabletLarge)} {
    margin-top: 0;
    grid-row: 1 / span 2;

    ${Container}:has(:not(${ButtonStyles.Container})) & {
      margin-top: auto;
      margin-bottom: auto;
    }
  }
`;
const ReadMore = styled.button `
  ${ButtonReset};
  ${transition('opacity, max-height')};
  ${paragraphRegular};
  ${link};

  margin: 8px 0 0;
  text-align: left;

  &[data-active='false'] {
    opacity: 0;
    pointer-events: none;
  }

  @media ${from(Device.TabletLarge)} {
    margin-left: auto;
  }
`;
const CtaWrapper = styled.div `
  ${rightColumns};

  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: ${fluid(8, 12)} ${fluid(8, 16)};

  ${Container}:has(${ReadMore}[data-active='true']) & {
    margin-top: 16px;

    @media ${from(Device.TabletLarge)} {
      margin-top: 12px;
    }
  }
`;
const InnerPageHeroStyles = {
    Container,
    CtaWrapper,
    Introduction,
    ReadMore,
    Subtitle,
    Title,
};
export default InnerPageHeroStyles;
